<template>
<div>
    <sav-spinner class="mb-3" v-if="loading" :size="10" />
    <sav-template v-if="canEditPassword" :title="$t('mot_de_passe_oublie.token.mot_de_passe_oublie')">
        <div class="shadow border border-gray-200 p-6 my-4 my-rounded bg-white">
            <h1 class="text-xl font-bold border-b pb-3 mb-3">{{$t('mot_de_passe_oublie.token.nouveau_mot_de_passe')}}</h1>
            <sav-input-password v-model="password" />
            <button :disabled="loading" @click="updatePassword" class="my-3 default-bg-color default-bg-color-hover:hover text-white duration-100 px-3 py-1.5 font-bold rounded-xl">
                <i class="fas fa-check mr-2"></i> {{$t('mot_de_passe_oublie.token.modifier')}}
            </button>
        </div>
    </sav-template>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import SavInputPassword from '../../../../components/SavInputPassword.vue'
import sha256 from 'js-sha256';

export default {
  components: { SavInputPassword },
    data() {
        return {
            loading: false,
            errors: [],
            password: null,
            user: null,
            canEditPassword: false
        }
    },
    methods: {
        async init() {
            this.errors = []
            this.loading = true
            let response = await apiService.post('veriftoken', {token_conso: this.$route.query.token})

            if (response.data.posts.post == 0) {
                this.$router.push({name: '404'})
            } else {
                // Get User
                let userResponse = await apiService.post('get_conso', {id_conso: response.data.posts.post})
                this.user = userResponse.data.posts.post
            }

            // Set form
            this.canEditPassword = true
            this.loading = false
        },

        async updatePassword() {
            if (this.password.valid) {
                let objData = {
                    prenom: this.user.prenom,
                    nom: this.user.nom,
                    mail: this.user.mail,
                    tel: this.user.tel,
                    id_conso: this.user.id,
                    password: sha256(this.password.password)
                }

                let response = await apiService.post('setconso', objData)
                this.$toast.success('Mot de passe modifié')
                localStorage.setItem('client_id', this.user.id)
                this.$router.push({name: 'home'})
            }
        }
    },
    mounted() {
        if (!this.$route.query.token) {
            this.$router.push({name: '404'})
        } else {
            this.init()
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/UserPasswordToken.vue